import React, { useState, useEffect, useContext } from "react";
import { EnvironmentContext } from "../../EnvironmentContext";
import apiconfig from "../../config/config";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import ImageUploading from "react-images-uploading";
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import APIServices from "../../services/APIServices";
import { setFormData } from "../../Redux/Actions";
import ButtonCompo from "../../Components/ButtonComponent/ButtonCompo";
import OutlineButton from "../../Components/Button/Outlinebutton";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import AlertComponent from "../../Components/Alert/Alert";
import { setAccessToken } from "../../Redux/Actions";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import "moment-timezone/data/packed/latest.json";
import "./Viewedit.css";

const MAX_FILE_SIZE = 5242880;

const Viewedit = ({ organiserManagementLength, setOrganiserManagementLength, setViewed }) => {
  const { environment } = useContext(EnvironmentContext)
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const userId = params?.id;
  const today = new Date().toISOString().split("T")[0];
  const formData = useSelector((state) => state.formData);
  const [previousExperience, setPreviousExperience] = useState("");
  const [eventTypes, setEventTypes] = useState("");
  const [checkedCount, setCheckedCount] = useState("");
  const [checkedYesNo, setCheckedYesNo] = useState("");
  const [checkedProfession, setCheckedProfession] = useState("");
  const [images, setImages] = useState([]);
  const [imagesFormData, setImagesFormData] = useState([]);
  const [imageError, setImageError] = useState(null);
  const [verifiedOrganiser, setVerifiedOrganiser] = useState("No");
  const [isLoading, setIsLoading] = useState(false);
  const [randomNumber, setRandomNumber] = useState(null);
  const [selectedDate, setSelectedDate] = useState(true);
  const [dateError, setDateError] = useState("");
  const [removeOrganiserWarnContainer, setRemoveOrganiserWarnContainer] = useState(false);
  const [verifiedOrganiserAlert, setVerifiedOrganiserAlert] = useState(false)
  const [errAlert, setErrAlert] = useState(false);
  const [acceptFormAlert, setAcceptFormAlert] = useState(false)
  const [rejectFormAlert, setRejectFormAlert] = useState(false)
  const [removeOrganiserAlert, setRemoveOrganiserAlert] = useState(false)
  const [requestFromAgainAlert, setRequestFromAgainAlert] = useState(false);
  const accessToken = useSelector((state) => state.accessToken);


  useEffect(() => {
    if (typeof window !== "undefined") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    APIServices.updateOrgansierManagementRequestViewed(formData?.user_id?._id)
      .then(res => {
        setOrganiserManagementLength(organiserManagementLength - 1)
        setViewed(Math.random())
      })
      .catch(err => {
        console.log('error updating the organsier request view status')
      })
  }, [])

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleImageUploading = (imageList, addUpdateIndex) => {
    const imageBody = [];
    if (imageError) {
      setImageError(null);
    }
    setImages(imageList);
    const formData = new FormData();
    formData.append("image", imageList?.[addUpdateIndex]?.file);
    for (var key of formData.entries()) {
      if (key[1]) {
        imageBody.push(key[1]);
      } else {
        return imageBody;
      }
    }
    setImagesFormData((prevArr) => {
      return [...prevArr, ...imageBody];
    });
  };

  // const handleDropdownChange = (e) => {
  //   setVerifiedOrganiser(e.target.value);
  // };

  const handleDropdownChange = (event) => {
    const value = event.target.value;
    setVerifiedOrganiser(value);
    handleKYCVerification(value);
  };

  useEffect(() => {
    if (formData) {
      setPreviousExperience(formData.previous_experience || "");
      setEventTypes(formData.interested_event_types || "");
      setCheckedCount(formData.trips_per_quarter || "");
      setCheckedYesNo(formData.events_by_mbt || "");
      setCheckedProfession(formData.occupation || "");
      setImages(formData.verification_id.map((url) => ({ dataURL: url })));
      setVerifiedOrganiser(formData.user_id.kyc_verification ? "Yes" : "No");
      if (formData.date) {
        setSelectedDate(new Date(formData.date).toISOString().substr(0, 10));
      } else {
        setSelectedDate(new Date().toISOString().substr(0, 10));
      }
    }
  }, [formData]);

  useEffect(() => {
    const tokenLocal = JSON.parse(localStorage.getItem("token"));
    if (!accessToken && tokenLocal) {
      dispatch(setAccessToken(tokenLocal));
      APIServices.setAuthToken(tokenLocal);
    } else if (!accessToken && !tokenLocal) {
      navigate("/login");
    }

    if (accessToken || tokenLocal) {
      const tokenToUse = accessToken || tokenLocal;
      setIsLoading(true);
      APIServices.setAuthToken(tokenToUse);
      const url = environment === "Production"
        ? apiconfig.production.apiBaseUrl
        : apiconfig.develpoment.apiBaseUrl;

      APIServices.setApiBaseUrl(url);

      APIServices.getFormByUserId(userId)
        .then((response) => {
          const form = response.data.form;
          dispatch(setFormData(form));
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error fetching event details: ", err);
          setIsLoading(false);
        });
    }
  }, [userId, randomNumber, environment, dispatch, accessToken, navigate]);

  const approveButtonClicked = () => {
    if (selectedDate === "") {
      setDateError("Please select a date.");
      return;
    }
    setIsLoading(true);

    const body = {
      form_status: "Approved",
      form_verification: "Approved",
      user_type: "organiser",
      form_expiration_date: selectedDate,
    };

    if (formData?.user_id?.form_verification === "Pending") {
      body.organiser_date = [
        moment().format('YYYY-MM-DD'),
        moment().format('HH:mm')
      ];
    }

    APIServices.adminApproveForm(userId, body)
      .then((response) => {
        setIsLoading(false);
        setRandomNumber(Math.random());
        setAcceptFormAlert(true)
      })
      .catch((err) => {
        console.log("Getting error while cancelling the event", err);
        setIsLoading(false);
        setErrAlert(true)
      });
  };

  const requestFormAgainButtonClicked = () => {
    APIServices.sendFormRequest(userId)
      .then((response) => {
        setIsLoading(false);
        setRandomNumber(Math.random());
        setRequestFromAgainAlert(true)
      })
      .catch((err) => {
        console.log("Getting error while cancelling the event", err);
        setIsLoading(false);
        setErrAlert(true)
      });
  };

  console.log(
    "my_organized_trips: ",
    formData?.user_id?.my_organized_trips.length
  );

  const removeOrganiserButtonClicked = () => {
    if (formData?.user_id?.my_organized_trips.length === 0) {
      setIsLoading(true);
      const body = {
        form_status: "Removed",
        form_verification: "Removed",
        user_type: "user",
      };
      APIServices.adminApproveForm(userId, body)
        .then((response) => {
          setIsLoading(false);
          setRandomNumber(Math.random());
          setRemoveOrganiserAlert(true)
        })
        .catch((err) => {
          console.log("Getting error while cancelling the event", err);
          setIsLoading(false);
          errAlert(true)
        });
    } else {
      setRemoveOrganiserWarnContainer(true);
    }
  };

  const rejectFormButtonClicked = () => {
    setIsLoading(true);
    console.log("Reject Form Button Clicked");
    const body = {
      form_status: "Rejected",
      form_verification: "Rejected",
      user_type: "user",
    };
    APIServices.adminApproveForm(userId, body)
      .then((response) => {
        // console.log(response);
        setIsLoading(false);
        setRandomNumber(Math.random());
        setRejectFormAlert(true)
      })
      .catch((err) => {
        console.log("Getting error while cancelling the event", err);
        setIsLoading(false);
        setErrAlert(true)
      });
  };

  const handleCloseDialougeOrganiser = () => {
    setRemoveOrganiserWarnContainer(false);
  };

  // console.log("verified ORganiser: ", formData?.user_id.kyc_verification);

  const handleKYCVerification = (value) => {
    const kycStatus = value === "Yes";
    const body = { kyc_verification: kycStatus };
    APIServices.updateKYCVerification(userId, body)
      .then((response) => {

        setIsLoading(false);
        setRandomNumber(Math.random());
        setVerifiedOrganiserAlert(true)
      })
      .catch((err) => {
        console.log("Getting error while cancelling the event", err);
        setIsLoading(false);
        setErrAlert(true)
      });
  };

  return (
    <div>
      <Backdrop
        sx={{
          color: "#ffffff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <AlertComponent
        open={verifiedOrganiserAlert}
        severity="success"
        onClose={() => setVerifiedOrganiserAlert(false)}
        text="Verified organiser status changed  successfully."
      />

      <AlertComponent
        open={acceptFormAlert}
        severity="success"
        onClose={() => setAcceptFormAlert(false)}
        text="Form approved successfully."
      />

      <AlertComponent
        open={rejectFormAlert}
        severity="success"
        onClose={() => setRejectFormAlert(false)}
        text="Form rejected successfully."
      />

      <AlertComponent
        open={removeOrganiserAlert}
        severity="success"
        onClose={() => setRemoveOrganiserAlert(false)}
        text="Organiser Removed successfully."
      />

      <AlertComponent
        open={requestFromAgainAlert}
        severity="success"
        onClose={() => setRequestFromAgainAlert(false)}
        text="Form Requested successfully."
      />

      <AlertComponent
        open={errAlert}
        severity="error"
        onClose={() => setErrAlert(false)}
        text="Something went wrong.Please try again after sometime."
      />
      <div className="div">
        <p className="left-text">profile ID</p>
        <p className="right-text-blue">{formData?.user_id?.profile_id}</p>
      </div>

      <div className="div">
        <p className="left-text">Onboarding ID</p>
        <p className="right-text">{formData?._id}</p>
      </div>

      <div className="div">
        <p className="left-text">First Name</p>
        <p className="right-text">{formData?.user_id?.firstName}</p>
      </div>

      <div className="div">
        <p className="left-text">Email ID</p>
        <p style={{ textDecoration: "underline" }} className="right-text">
          {formData?.user_id?.email}
        </p>
      </div>

      <div className="div">
        <p className="left-text">Verified status</p>
        <p className="right-text">{formData?.form_status}</p>
      </div>
      {/* <div className="div">
        <p className="left-text">Verified organiser</p>
        <select
          className="right-text-blue"
          value={verifiedOrganiser}
          onChange={handleDropdownChange}
        >
          <option style={{ color: "#595959" }} value="Yes">
            Yes
          </option>
          <option style={{ color: "#595959" }} value="No">
            No
          </option>
        </select>
      </div> */}
      <div className="div">
        <p className="left-text">Verified organiser</p>
        <select
          className="right-text-blue"
          // value={formData.user_id.kyc_verification}
          value={verifiedOrganiser}
          onChange={handleDropdownChange}
        >
          <option style={{ color: "#595959" }} value="Yes">
            Yes
          </option>
          <option style={{ color: "#595959" }} value="No">
            No
          </option>
        </select>
      </div>

      <br></br>
      <p className="red-text">Onboarding details</p>
      <div className="text-fields">
        <h5 className="text-field-text">
          1. What motivates you to become an organiser with Meetbytravel? Share
          your previous experiences if any
        </h5>
        <TextField
          sx={{
            "& .MuiInputBase-input": {
              fontFamily: "poppins",
              letterSpacing: "0.1px",
              fontSize: "12px",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "black",
            },
          }}
          value={previousExperience}
          rows={3}
          multiline
          type="text"
          style={{ fontFamily: "poppins", width: "80%", marginTop: "10px" }}
          placeholder="Share Your experience"
          required
          InputLabelProps={{ shrink: true }}
          disabled
        />
        <br></br>
        <h5 className="text-field-text">
          2. What types of events are you interested in organising through
          Meetbytravel?
        </h5>
        <TextField
          sx={{
            "& .MuiInputBase-input": {
              fontFamily: "poppins",
              letterSpacing: "0.1px",
              fontSize: "12px",
            },
            "& .MuiInputBase-input.Mui-disabled": {
              WebkitTextFillColor: "black",
            },
          }}
          value={eventTypes}
          onChange={(e) => setEventTypes(e.target.value)}
          size="small"
          type="text"
          style={{ fontFamily: "poppins", width: "80%", marginTop: "10px" }}
          placeholder="Type of event you interested in"
          required
          InputLabelProps={{ shrink: true }}
          disabled
        />
        <br></br>
        <h5 className="text-field-text">
          3. How many events do you anticipate hosting per quarter (3 months)?
        </h5>
        <Stack direction="column">
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedCount === "one_trip"}
                name="one_trip"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                One trip
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedCount === "two_three"}
                name="two_three"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                2 - 3 trips
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedCount === "four_five"}
                name="four_five"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                4 - 5 trips
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedCount === "six_seven"}
                name="six_seven"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                6 - 7 trips
              </Typography>
            }
          />
        </Stack>
        <br></br>
        <h5 className="text-field-text">
          4. Have you organised events for Meetbybefore?
        </h5>
        <Stack direction="column">
          <FormControlLabel
            control={
              <Checkbox checked={checkedYesNo === "yes"} name="yes" disabled />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                Yes
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox checked={checkedYesNo === "no"} name="no" disabled />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                No
              </Typography>
            }
          />
        </Stack>
        <br></br>
        <h5 className="text-field-text">5. Your Profession?</h5>
        <Stack direction="column">
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedProfession === "student"}
                name="Student"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                Student
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedProfession === "working"}
                name="influencer"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                Working Profession
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={checkedProfession === "other"}
                name="other"
                disabled
              />
            }
            label={
              <Typography variant="body1" fontFamily="Poppins" fontSize="14px">
                Others
              </Typography>
            }
          />
        </Stack>
        <br></br>
        <h5 className="text-field-text">
          6. Please upload any documents or images to support your application
        </h5>
        <ImageUploading
          value={images}
          onChange={handleImageUploading}
          maxNumber={5}
          maxFileSize={MAX_FILE_SIZE}
          onError={(errors) => {
            if (errors.maxFileSize) {
              setImageError("File size should not exceed 5MB");
            }
          }}
        >
          {({
            imageList,
            onImageUpload,
            onImageUpdate,
            onImageRemove,
            isDragging,
            dragProps,
          }) => (
            <div
              className="upload__image-wrapper"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                fontFamily: "Poppins",
                marginTop: "10px",
              }}
            >
              <br />
              {imageError && <p style={{ color: "red" }}>{imageError}</p>}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "flex-start",
                }}
              >
                {imageList.map((image, index) => (
                  <div key={index} className="image-item">
                    <img
                      src={image.dataURL}
                      alt=""
                      width="100"
                      style={{
                        margin: "10px 0",
                        objectFit: "cover",
                        border: "1px solid #ddd",
                        borderRadius: "5px",
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </ImageUploading>
        <br />
        {/* <div className="mb-4">
          <TextField
            id="myDatePicker"
            label="Select Date"
            type="date"
            value={selectedDate}
            onChange={handleDateChange}
            InputLabelProps={{
              shrink: true,
            }}
            inputProps={{
              min: today,
            }}
          />
          {dateError && (
            <p className="error-text" style={{ color: "red" }}>
              {dateError}
            </p>
          )}
        </div> */}
        <Dialog
          open={removeOrganiserWarnContainer}
          aria-labelledby="report-dialog-title"
          aria-describedby="report-dialog-description"
        >
          <Box
            sx={{
              width: "500px",
              height: "200px",
              backgroundColor: "white",
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <div
              style={{
                alignSelf: "flex-end",
                padding: "10px",
              }}
            >
              <CloseIcon
                onClick={handleCloseDialougeOrganiser}
                style={{ cursor: "pointer" }}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <p
                style={{
                  alignSelf: "flex-start",
                  margin: "13px",
                  fontFamily: "poppins",
                  fontWeight: "500",
                  color: "#232323",
                  fontSize: "15px",
                }}
              >
                You can't remove this organiser
              </p>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Button
                variant="text"
                style={{
                  color: "#E34242",
                  fontFamily: "poppins",
                  fontSize: "16px",
                  fontWeight: "400",
                  height: "35px",
                  width: "140px",
                  border: "2px solid #E34242",
                  textTransform: "capitalize",
                  borderRadius: "15px",
                }}
                onClick={handleCloseDialougeOrganiser}
              >
                Cancel
              </Button>
            </div>
          </Box>
        </Dialog>
        <div className="button-group">
          {formData?.user_id?.form_verification === "Pending" ? (
            <div className="approve-buttons-container">
              <ButtonCompo btnText="Approve" onClick={approveButtonClicked} />
              <OutlineButton
                buttonText="Reject"
                onClick={rejectFormButtonClicked}
              />
            </div>
          ) : formData?.user_id?.user_type === "organiser" ? (
            <div className="approve-buttons-container">
              <OutlineButton
                buttonText="Request form again"
                onClick={requestFormAgainButtonClicked}
              />
              <OutlineButton
                buttonText="Remove as organiser"
                onClick={removeOrganiserButtonClicked}
              />
            </div>
          ) : (
            <div className="approve-buttons-container">
              <OutlineButton
                buttonText="Request form again"
                onClick={requestFormAgainButtonClicked}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Viewedit;
